const COLORS = {
  volt: { bg: "rgba(245,197,24,0.1)", c: "#F5C518" },
  green: { bg: "rgba(34,197,94,0.1)", c: "#22C55E" },
  blue: { bg: "rgba(59,130,246,0.1)", c: "#3B82F6" },
  purple: { bg: "rgba(167,139,250,0.1)", c: "#A78BFA" },
  gray: { bg: "rgba(144,144,168,0.08)", c: "#9090A8" },
};

export default function Chip({ label, color = "gray", small = false }) {
  const s = COLORS[color] || COLORS.gray;
  return (
    <span
      style={{
        fontSize: small ? 10 : 11,
        fontWeight: 600,
        padding: small ? "3px 9px" : "5px 11px",
        borderRadius: 100,
        background: s.bg,
        color: s.c,
        whiteSpace: "nowrap",
        display: "inline-block",
      }}
    >
      {label}
    </span>
  );
}

const SIGNAL_LABELS = {
  funding: ["Funding", "volt"],
  hiring: ["Hiring", "green"],
  expansion: ["Expansion", "blue"],
  leadership: ["New exec", "purple"],
  general: ["Signal", "gray"],
};

export function SignalChip({ type }) {
  const [label, color] = SIGNAL_LABELS[type] || SIGNAL_LABELS.general;
  return <Chip label={label} color={color} small />;
}
